module.exports = __webpack_public_path__ + "static/p6-1afd4134b4cfad7f94ce1206214d4ea4.jpg";